import { SidebarToggleButton } from '@/components/SidebarToggleButton';
import { UniversalSearchButton } from '@/components/UniversalSearchButton';
import { QuickActions } from '@/modules/QuickActions';
import { useAiChatSidebarState } from '@/views/ai-chat/ai-chat-state';

export const PageTopBar = () => {
    const { isOpen, toggle } = useAiChatSidebarState();
    return (
        <div className="px-6">
            <div className="flex h-[70px] min-w-0 items-center gap-4">
                <QuickActions variant="header" label="Actions" />
                <UniversalSearchButton className="min-w-0 flex-1" />
                <SidebarToggleButton
                    isOpen={isOpen}
                    onToggle={toggle}
                    openLabel="Open Claire™"
                    closeLabel="Close Claire™"
                />
            </div>
        </div>
    );
};
